// src/pages/factors/FactorsSkeleton.jsx
import React from 'react';

export default function FactorsSkeleton() {
  return (
    <div className="card">
      <div className="skeleton skeleton-title" />
      {[1, 2, 3, 4].map((i) => (
        <div key={i} className="skeleton skeleton-row" />
      ))}

      <style>{`
        .skeleton {
          background: linear-gradient(
            90deg,
            var(--border) 25%,
            var(--border-strong) 50%,
            var(--border) 75%
          );
          background-size: 200% 100%;
          animation: skeleton-shimmer 1.4s ease-in-out infinite;
          border-radius: 8px;
        }
        @keyframes skeleton-shimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
        .skeleton-title {
          height: 22px;
          width: 40%;
          margin-bottom: 20px;
        }
        .skeleton-row {
          height: 72px;
          width: 100%;
          margin-bottom: 12px;
          border-radius: 16px;
        }
      `}</style>
    </div>
  );
}
